import styled from "styled-components";

import { Form } from "react-bootstrap";
import { Dropdown ,Menu} from "antd";

export const Dropdowns = styled(Dropdown)``;
export const DropdownsMenu = styled(Menu)``;
